import React from 'react';
import i18n from 'i18next';
import { useLanguage } from 'react-lib/dist/hooks-es';
import { ChooseLanguage } from 'react-lib/dist/components-es';
import Connector from '../../../agent';
import styles from './ChooseLanguageWrapper.module.scss';

const { api } = Connector;

function ChooseLanguageWrapper() {
  const [, setLang] = useLanguage(api, i18n);

  return (
    <div className={styles.languages}>
      <ChooseLanguage language={i18n.language} updateLanguage={setLang} />
    </div>
  );
}

export default ChooseLanguageWrapper;
